import React from "react";

const NoPermission = () => {
  return (
    <div className="bg-gray-100 flex items-center justify-center h-screen">
      <div className="text-center space-y-6 px-4 max-w-md">
        <div className="text-red-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-16 h-16 mx-auto"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.5 10.5V9a4.5 4.5 0 00-9 0v1.5M7.5 10.5h9a2.25 2.25 0 012.25 2.25v6.75A2.25 2.25 0 0116.5 21H7.5a2.25 2.25 0 01-2.25-2.25v-6.75A2.25 2.25 0 017.5 10.5z"
            />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-gray-800">Access Denied</h1>
        <p className="text-gray-600">
          You don't have permission to access this page. Please contact the
          administrator if you think this is a mistake.
        </p>
        <a
          href="/"
          className="bg-red-500 mt-5 text-white px-6 py-3 rounded-md shadow hover:bg-red-600 transition duration-300"
        >
          Go Back Home
        </a>
      </div>
    </div>
  );
};

export default NoPermission;
